import {useEffect, useState} from "react";
import {useParams} from "react-router-dom";
import _axios from "../../../../httpService"
import Loader from "../../../Loader";

const StaticForm = () => {
        const id = useParams()['id'];

        const [optionData, setOptionData] = useState([]);

        useEffect(() => {
            //آقایبکلطفااطلاعاتروازبکبگیربفرست
            //let temp = _axios.get("","");
            let temp = [{"name": "آپشنبرگشتیازبکاول", "value": "v1"}, {
                "name": "آپشنبرگشتیازبکدوم",
                "value": "v2"
            }, {"name": "آپشنبرگشتیازبکسوم", "value": "v3"}, {"name": "آپشنبرگشتیازبکچهارم", "value": "v4"},]
            //مثلادیتاظرف2ثانیهازبکمیاد...
            setTimeout(() => setOptionData(temp), 2000)
        }, [])

        const [selectedValue, setSelectedValue] = useState("")

        function changeHandler(event) {
            setSelectedValue(event.target.value)

        }

        function registerForm(event) {
            event.preventDefault()



            // بفرما اطلاعات جدید
            // _axios.post("", "id").then(res => {
            //
            // })

        }

        return (<div>

            <div
                className="selectWidthComplete">
                <label
                    htmlFor="id3"
                    className="control-labelform-labellabelMargin">
                    انتخاب
                    فرم
                </label>
                {optionData.length === 0 ? <Loader/>
                    :
                    <select
                        OnChange={changeHandler}
                        defaultValue={"nullSelect"}
                        className="inputBox"
                        id="id3">
                        <option value={"nullSelect"}>گزینه مورد نظر خود را انتخاب کنید</option>
                        {optionData && optionData.map(v => (<option
                            value={v.value}>{v.name}</option>))}
                    </select>
                }
            </div>


            <div className="button-box mx-auto my-3 twoBtn w-100 text-center ">
                <button onClick={registerForm} type="submit" className="btn btn-primary my-4">ثبت</button>
            </div>

        </div>);
    }
;

export default StaticForm;
